import type { EnterpriseContentAssignment_LearnerContentAssignment as AssignedCourse } from '__generated__/graphql-types';

import type { CarouselCollection } from 'bundles/collections-carousel/types/CarouselCollection';
import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';
import { LEARNING_PRODUCTS } from 'bundles/search-common/constants';
import ROUTE_CONFIG from 'bundles/unified-description-page-common/constants/routeConfig';

export const mapAssignedContentToCollection = (programSlug: string, assignedContent?: Array<AssignedCourse>) => {
  if (!assignedContent?.length) {
    return undefined;
  }

  return {
    collectionId: 'assigned-courses',
    title: '',
    entities: assignedContent.map(({ content }, index) => {
      if (content.__typename === 'Specialization_Specialization') {
        const { id, slug, name, partners, cardImageUrl } = content;
        return {
          id: `SPECIALIZATION~${id}`,
          name,
          slug,
          imageUrl: cardImageUrl,
          link: `/programs/${programSlug}/${ROUTE_CONFIG.SPECIALIZATIONS.pathname}/${slug}`,
          partners,
          partnerLogos: partners?.map(({ squareLogo }) => squareLogo),
          productType: LEARNING_PRODUCTS.Specialization,
          trackingData: {
            entityId: `SPECIALIZATION~${id}`,
            entityIndex: index,
            name,
            slug,
            offeringType: LEARNING_PRODUCTS.Specialization,
            id,
          },
        };
      }
      if (content.__typename === 'Course_Course') {
        const { id, slug, name, partners, promoPhotoUrl } = content;
        return {
          id: `COURSE~${id}`,
          name,
          slug,
          imageUrl: promoPhotoUrl,
          link: `/programs/${programSlug}/${ROUTE_CONFIG.COURSE.pathname}/${slug}`,
          partners,
          partnerLogos: partners?.map(({ squareLogo }) => squareLogo),
          productType: LEARNING_PRODUCTS.Course,
          trackingData: {
            entityId: `COURSE~${id}`,
            entityIndex: index,
            name,
            slug,
            offeringType: LEARNING_PRODUCTS.Course,
            id,
          },
        };
      }
      return null;
    }),
    collectionTrackingData: {
      collectionId: 'assigned-courses',
      collectionName: 'Assigned to you',
    },
  } as CarouselCollection;
};

export const getUserLevelLearingGoalVariant = () => GrowthDiscoveryExperiments.get('userLevelLearningGoal');

export const USER_LEVEL_LEARNING_GOAL_VARIANT = {
  control: 'control',
  B: 'B',
  C: 'C',
};

export const showCareerRolesCollection = () => GrowthDiscoveryExperiments.preview('showCareerRolesCollection');
